import { QueryCache, QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query?.meta?.onError && typeof query.meta.onError === "function") {
        query.meta.onError(error);
      }
      if (query?.meta?.navigateFn && typeof query.meta.navigateFn === "function" && query?.meta?.navigateTo) {
        query?.meta?.navigateFn({ to: query.meta.navigateTo });
      }
    },
  }),
});

export default queryClient;
